var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isReadOnly)?_c('AppButtonReadonly',{staticStyle:{"display":"flex"},on:{"click":_vm.simulationEdit}}):_vm._e(),(!_vm.isReadOnly)?_c('AppIconEdit',{staticStyle:{"display":"flex"},on:{"click":_vm.simulationEdit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }